import styled from "styled-components";

export const MAnnouncementSection = styled.div`
  width: 100%;
  height: 95%;
`;
export const MAnnouncementItemSection = styled.div`
	padding: 10px;
`
